"use client"

import Link from "next/link"
import React from "react"

type LocalizedClientLinkProps = {
  children?: React.ReactNode
  href: string
  className?: string
  onClick?: () => void
  passHref?: true
  prefetch?: boolean
  [x: string]: any
}

const LocalizedClientLink = ({
  children,
  href,
  prefetch = false,
  ...props
}: LocalizedClientLinkProps) => {
  return (
    <Link href={href} prefetch={prefetch} {...props}>
      {children}
    </Link>
  )
}

export default LocalizedClientLink
